/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Landing_Browsetitle1Inputs */

const en_welcome_landing_browsetitle1 = /** @type {(inputs: Welcome_Landing_Browsetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse offering`)
};

/**
* | output |
* | --- |
* | "Browse offering" |
*
* @param {Welcome_Landing_Browsetitle1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const welcome_landing_browsetitle1 = /** @type {((inputs?: Welcome_Landing_Browsetitle1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Landing_Browsetitle1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_landing_browsetitle1(inputs)
});
export { welcome_landing_browsetitle1 as "welcome_landing_browseTitle" }